import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {fetchTransactionTypeById, updateTransactionType} from "../../store/transaction-type-slice";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import Form from "../../components/common/form/Form";
import {getFormData} from "../../models/transactionTypeModel";
import {transactionTypeSchema} from "../../schema/transactionTypeSchema";

const TransactionTypeEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.transactionType);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.transactionType);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchTransactionTypeById({...userRole, id: params.transactionTypeId}));
    }, [dispatch, params.transactionTypeId, userRole]);

    const transactionType = items.find(item => item.id === params.transactionTypeId);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [updateStatus, dispatch, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        delete data.systemGen;
        dispatch(updateTransactionType({...userRole, data, id: params.transactionTypeId}));
    }

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    }

    const initialData = getFormData(transactionType)
    const schema = transactionTypeSchema();
    return (
        <>
            <SubHeader title="Update Transaction Type">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={updateStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default TransactionTypeEdit;